<template>
    <v-snackbar v-model="triggerSnackbar" :color="color">
        {{ text }}
    </v-snackbar>
</template>

<script>
export default {
    data(){
        return {
            text: this.setText(),
            textType: "",
            color: ""
        }
    },
    methods: {
        resetTrigger(){
            this.$store.state.snackbarTrigger = false;
        },
        setText(){
            //console.log('textType: ' + this.textType);

            switch (this.$store.state.snackbarType) {
                case "success":
                    this.text = "Sparad";
                    this.color = "success";
                    break;
                case "offline":
                    this.text = "Kunde inte skicka transaktion, vänligen anslut till internet.";
                    this.color = "error";
                    break;
                case "fail":
                    this.text = "Transaktionen misslyckades," +
                    " ett till försök kommer att göras.";
                    this.color = "error";
                    break;
                default:
                    this.text = "Något gick fel";
                    break;
            }
            //console.log('Type: ' + this.textType);
            return this.text;
        }
    },
    computed:{
        triggerSnackbar:{
            get(){
                this.setText();
                return this.$store.state.snackbarTrigger;
            },
            set(){}
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Snackbar.vue